module.exports = __webpack_public_path__ + "img/Empty_NoData_light@2x.034026e7.png";